import { combineReducers } from 'redux';
import register from './registerReducer';
import login from './loginReducer';
import donor from './donorReducer';
import patient from './patientReducer';
import locality from './localityReducer';
import places from './placesReducer';
import admin from './adminReducer';

const rootReducer = combineReducers({
  register, login, donor, patient, places, locality, admin
});

export default rootReducer;